import React, { useState, useEffect, useContext } from 'react';
import axios from 'axios';
import { AuthContext } from '../contexts/AuthContext';
import './Gallery.css';

const Gallery = () => {
  const [gallery, setGallery] = useState([]);
  const [category, setCategory] = useState('');
  const [showForm, setShowForm] = useState(false);
  const [formData, setFormData] = useState({ category: '线路图', name: '' });
  const [selectedFile, setSelectedFile] = useState(null);
  const { user } = useContext(AuthContext);

  const fetchGallery = async (cat = '') => {
    try {
      const params = cat ? { category: cat } : {};
      const res = await axios.get('/gallery', { params });
      setGallery(res.data);
    } catch (err) {
      console.error('获取画廊失败:', err);
    }
  };

  useEffect(() => {
    fetchGallery(category);
  }, [category]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const data = new FormData();
      data.append('category', formData.category);
      data.append('name', formData.name);
      if (selectedFile) {
        data.append('image', selectedFile);
      }

      await axios.post('/gallery', data, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });

      setFormData({ category: '线路图', name: '' });
      setSelectedFile(null);
      setShowForm(false);
      fetchGallery(category);
    } catch (err) {
      console.error('上传失败:', err);
    }
  };

  const handleDelete = async (id) => {
    if (window.confirm('确定要删除这张图片吗？')) {
      try {
        await axios.delete(`/gallery/${id}`);
        fetchGallery(category);
      } catch (err) {
        console.error('删除失败:', err);
      }
    }
  };

  return (
    <div className="gallery">
      <h1>画廊</h1>
      
      <div className="category-tabs">
        <button
          className={category === '' ? 'active' : ''}
          onClick={() => setCategory('')}
        >
          全部
        </button>
        <button
          className={category === '线路图' ? 'active' : ''}
          onClick={() => setCategory('线路图')}
        >
          线路图
        </button>
        <button
          className={category === '优秀作品' ? 'active' : ''}
          onClick={() => setCategory('优秀作品')}
        >
          优秀作品
        </button>
      </div>

      {user && (user.permission === '腐竹' || user.permission === '管理') && (
        <div className="admin-controls">
          <button onClick={() => setShowForm(!showForm)} className="btn-primary">
            {showForm ? '取消' : '上传图片'}
          </button>
        </div>
      )}

      {showForm && (
        <form onSubmit={handleSubmit} className="gallery-form">
          <select
            value={formData.category}
            onChange={(e) => setFormData({ ...formData, category: e.target.value })}
          >
            <option value="线路图">线路图</option>
            <option value="优秀作品">优秀作品</option>
          </select>
          <input
            type="text"
            placeholder="图片名称"
            value={formData.name}
            onChange={(e) => setFormData({ ...formData, name: e.target.value })}
            required
          />
          <input
            type="file"
            accept="image/*"
            onChange={(e) => setSelectedFile(e.target.files[0])}
            required
          />
          <button type="submit" className="btn-primary">上传</button>
        </form>
      )}

      <div className="gallery-grid">
        {gallery.map((item) => (
          <div key={item._id} className="gallery-item">
            <img src={`https://longtengrailway.top${item.image}`} alt={item.name} />
            <div className="gallery-info">
              <h4>{item.name}</h4>
              <span className="gallery-category">{item.category}</span>
              {user && (user.permission === '腐竹' || user.permission === '管理') && (
                <button onClick={() => handleDelete(item._id)} className="btn-delete">删除</button>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Gallery;
